import React, { Component } from 'react';
import MainLayout from '../mainLayout';
import Select from 'react-select';
import { Player, ControlBar, PlayToggle } from "video-react";
// Components
import TextField from '../component/TextField';
import HomePageTile from "../component/HomePageTile";
import Loader from '../component/loader';
import ErrorPopUp from '../component/errorPopUp';
import TextEdtor from './../component/TextEditor';

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

// Images import
import QuestionIcon from "../assets/images/question_icon.svg";
import PlusIcon from "../assets/images/plus_icon.svg";
import calendar from "../assets/images/calendar.svg";
// import placeHolderImage  from ";

import home_page from "../assets/images/home_page.jpg";
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
//  Date Picker
import DatePicker from "react-datepicker";

//moment import
import moment from "moment";

//sweet alert
import swal from 'sweetalert';

//Service import
import service from '../services'

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

// Import css files
import "react-datepicker/dist/react-datepicker.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import commonImage from '../commonImage';

let sub;


class HomePageCms extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            headerTitle:'',
            headerSubTitle:EditorState.createEmpty(),
            countDownDate:new Date(),
            countDownTime:'',
            countDownText:'',
            homeVideo:'',
            homeVideoThumbnail:'',
            Hours:'7',
            Mins:'30',
            Stamps:'AM',
            tile:[],
            errorPopup:false,
            errorMsg:'',
            imageErr:'',
            TileErr:'',
            thumbnailPreloader:false,
            fourTiles:[
                {
                    _id:Math.random(),
                    tileObj:'Tile 1',
                    tileImage: '',
                    tileImageDescription: '',
                    tileTitle: '',
                    tileSubTitle1: '',
                    tileSubTitle2: '',
                    tileCTA: '',
                    tileUrl: '',
                    tileOutbound:false,
                    tileUrlError:''
                },
                {
                    _id:Math.random(),
                    tileObj:'Tile 2',
                    tileImage: '',
                    tileImageDescription: '',
                    tileTitle: '',
                    tileSubTitle1: '',
                    tileSubTitle2: '',
                    tileCTA: '',
                    tileUrl: '',
                    tileOutbound:false,
                    tileUrlError:''
                },
                {
                    _id:Math.random(),
                    tileObj:'Tile 3',
                    tileImage: '',
                    tileImageDescription: '',
                    tileTitle: '',
                    tileSubTitle1: '',
                    tileSubTitle2: '',
                    tileCTA: '',
                    tileUrl: '',
                    tileOutbound:false,
                    tileUrlError:''
                },
                {
                    _id:Math.random(),
                    tileObj:'Tile 4',
                    tileImage: '',
                    tileImageDescription: '',
                    tileTitle: '',
                    tileSubTitle1: '',
                    tileSubTitle2: '',
                    tileCTA: '',
                    tileUrl: '',
                    tileOutbound:false,
                    tileUrlError:''
                }
            ],
            videoPreLoader:false,          
        };
        this.apiserve = new service();
   
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    componentDidMount = () => {
        this.getFPGHomePage()
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "FPGHomePage|updateSettings":
                    if(response.data.error){
                        this.setState({
                            errorPopup:true,
                            errorMsg:response.data.error
                        })
                    }else{
                        this.setState({
                            loaderFlag: false
                        })
                        this.getFPGHomePage()
                        this.apiserve.success('Update Successfully.')
                    }
                break;

              
                case "FPGHomePage|getSettings":
                    if(response.error){
                        // this.setState({
                        //     errorPopup:true,
                        //     errorMsg:response.data.error
                        // })
                    }else{
                        const blocksFromHtml = htmlToDraft(response.data.headerSubTitle);
                        const { contentBlocks, entityMap } = blocksFromHtml;
                        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                        const editorState = EditorState.createWithContent(contentState);

                        response && response.data && response.data.tile.map(item=>{
                            const blocksFromHtml = htmlToDraft(item.tileSubTitle1);
                            const { contentBlocks, entityMap } = blocksFromHtml;
                            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            item.tileSubTitle1 = EditorState.createWithContent(contentState);
                        })

                        response && response.data && response.data.tile.map(item=>{
                            const blocksFromHtml = htmlToDraft(item.tileSubTitle2);
                            const { contentBlocks, entityMap } = blocksFromHtml;
                            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            item.tileSubTitle2 = EditorState.createWithContent(contentState);
                        })
                        
                        let Hours = moment(response.data.countDownDate).format('h')
                        let Mins = moment(response.data.countDownDate).format('mm')
                        let Stamps = moment(response.data.countDownDate).format('A')
                        this.setState({
                                headerTitle: response.data.headerTitle,
                                editorState: editorState,
                                // headerSubTitle: response.data.headerSubTitle,
                                countDownDate:new Date(response.data.countDownDate),
                                Hours: { value: Hours, label: Hours },
                                Mins: { value: Mins, label: Mins },
                                Stamps:{ value: Stamps, label: Stamps },
                                countDownTime: response.data.countDownTime,
                                countDownText: response.data.countDownText,
                                homeVideo: response.data.homeVideo,
                                updatedAt:response.data.updatedAt,
                                updateBy:response.data.user,
                                homeVideoThumbnail:response.data.homeVideoThumbnail
                            },()=>{
                                if(response.data.tile === undefined){
                                    this.setState({
                                        fourTiles:this.state.fourTiles
                                    })
                                }else{
                                    this.setState({
                                        fourTiles:response && response.data && response.data.tile
                                    })
                                }
                           })
                    }
                    
                break;
                }
            
        });
    }

    setEditorObjectText=(text)=>{
        const blocksFromHtml = htmlToDraft(text ? text : '');
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        return EditorState.createWithContent(contentState);
    }

    getFPGHomePage = () => {
        this.apiserve.sendevent("FPGHomePage|getSettings", {})    
    }

    handleText = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    onEditorStateChange = (editorState,id, str) => {
        if(id){
            this.state.fourTiles.map(item=>{
                if(item._id === id){
                    if(str===1){
                        item.tileSubTitle1 = editorState
                    }
                    else{
                        item.tileSubTitle2 = editorState
                    }
                }
            })
            this.forceUpdate();
        }else{
            this.setState({
                editorState,
              });
        }
      };

    handleChangeTile = (e,item) => {
        this.setState({})
        const { name, value, _id } = e.target;
        this.state.fourTiles.forEach(event => {
            if(event._id === item._id){
                event[name] = value
            }
        })
        this.setState({})
    }
    

    handleTimeHours = (e) => {
        this.setState({
            Hours:e
        })
    }

    handleTimeMins = (e) => {
        this.setState({
            Mins:e,
        })
    }

    handleTimeStamps = (e) => {
        this.setState({
            Stamps:e,
        })
    }

    handleChange = (e) => {
       this.setState({
              countDownDate: e,
        });
    }

    handleChangeBound = (e,item) => {        
        const { name, value } = e.target;
        var data = {}
        this.state.fourTiles.forEach(element => {
            if(element._id === item._id){
            element.tileOutbound=JSON.parse(value)
           }
           if(element.tileOutbound === false){
            element.tileUrl = ''
           }
            
        });

        this.setState({})
    }

    handleImageChange = (e,id) => {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
          this.setState({
            file: file,
          },()=>{
         this.uploadImage.value = "";


        const fileList = Math.round((file && file.size / 1024));
        if (fileList >= 3072) {        
          this.setState({
            errorPopup:true,
            errorMsg: 'Please upload a file smaller than 3 MB'           
           })
            return false;
        } 
        if(file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg' ){
            setTimeout(() => {
                this.imageUpload(file,id,event.target.result);
            }, 1000)
        }else{
            this.setState({
                errorPopup:true,
                errorMsg: 'Please upload a file for PNG,JPG or JPEG'           
            })
        }       
    })
    }
    }
    

    imageUpload = (file,id, img) => {        
        const imagePreloaderId = `imagePreloader_${id}`
        const newState = {...this.state}
        newState[imagePreloaderId] = true
        this.setState(newState)
        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
            this.state.fourTiles.forEach(event => {
                
              if(event._id === id)
                    {
                        const imagePreloaderId = `imagePreloader_${id}`
                        const newState = {...this.state}
                        newState[imagePreloaderId] = false
                        this.setState(newState)
                        setTimeout(()=>{})
                        event.tileImage = value
                    }
                  });
                     
                   this.setState({})
            });
    };

    handleThumbnail = (e) => {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
          this.setState({
            file: file,
            // base64: reader.result
          },()=>{
        this.thumbnail.value = "";
        const fileList = Math.round((this.state.file && this.state.file && this.state.file.size / 1024));
        if (fileList >= 3072)
        {        
            this.setState({
              errorPopup:true,
              errorMsg: 'Please upload a file smaller than 3 MB'           
             })
              return false;
          } 
          if(this.state.file && this.state.file && (file.type === 'image/png' || file.type === 'image/jpg' ||  file.type === 'image/jpeg')){
              setTimeout(() => {
                  this.imageThumbnail (file,event.target.result);
              }, 1000)
          }else{
              this.setState({
                  errorPopup:true,
                  errorMsg: 'Please upload a file for PNG,JPG or JPEG'           
              })
          }
        })     
        }
        
    }

    imageThumbnail = (file,img) => {
        this.setState({thumbnailPreloader:true})
        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
                this.setState({
                    thumbnailPreloader:false,
                    homeVideoThumbnail:value
                })
            });
    };

    handleVideo = (e) => {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        
        reader.onloadend = (event) => {
            this.setState({
                file: file,
                // base64: reader.result
            }, () =>{
            this.videoUp.value = "";
 
            if (file.size > 200e6) {
        
                this.setState({
                  errorPopup:true,
                  errorMsg: 'Please upload a video smaller than 200 MB'           
                 })
                  return false;
                }
                
                if(file.type === 'video/mp4' ){
                    setTimeout(() => {
                        this.videoUpload(file,event.target.result);
                    }, 1000)
                }else{
                    this.setState({
                        errorPopup:true,
                        errorMsg: 'Please upload only MP4 file'           
                       })
                } 
                
        })
        }
    }

    videoUpload = (file, img) => {
        this.setState({videoPreLoader:true})
        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
                this.setState({
                    videoPreLoader:false,
                    homeVideo: value,
                });
            });
    };

    submit = () => {  
         
        var isValid = true 
        this.state.fourTiles.forEach(tile => {
            this.validationUrl(tile._id)
        });

        this.state.fourTiles.forEach(element => {
            if(element.tileUrlError === 'Please enter valid url.')
            {
                isValid= false
            }
        });
        
        if (isValid) {
            this.setState({ loaderFlag: true })
            let countDownDateFinal1 = new Date(this.state.countDownDate)
            var countDownDateFinal = new Date(this.state.countDownDate);
            // countDownDateFinal.setHours( this.state.Stamps.value === 'PM' || this.state.Stamps.value === 'pm' ? parseInt(this.state.Hours.value) + 12 : parseInt(this.state.Hours.value), this.state.Mins.value);
            countDownDateFinal.setHours( this.state.Stamps.value === 'PM' || this.state.Stamps.value === 'pm' ? parseInt(this.state.Hours.value) === 12 ? parseInt(this.state.Hours.value) : parseInt(this.state.Hours.value) + 12 : parseInt(this.state.Hours.value) === 12 ? parseInt(this.state.Hours.value) -12 : parseInt(this.state.Hours.value)  , this.state.Mins.value);
            const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
            const  markup= draftToHtml(name);

            var list =[];
             this.state.fourTiles.map(item=>{
                const name1 = item.tileSubTitle1  ? convertToRaw(item.tileSubTitle1.getCurrentContent()) : ''
                 const  markup1= draftToHtml(name1);
                 item.tileSubTitle1 = markup1;

                 const name2 = item.tileSubTitle2  ? convertToRaw(item.tileSubTitle2.getCurrentContent()) : ''
                 const  markup2= draftToHtml(name2);
                 item.tileSubTitle2 = markup2;

                 list.push(item);
            })
            
            var data={
                headerTitle: this.state.headerTitle,
                headerSubTitle: markup,
                countDownDate:countDownDateFinal1 ? countDownDateFinal1 : countDownDateFinal,
                homeVideoThumbnail:this.state.homeVideoThumbnail,
                // countDownTime: time,
                Hours:this.state.Hours.value,
                Mins:this.state.Mins.value,
                Stamps:this.state.Stamps.value,
                countDownText: this.state.countDownText,
                homeVideo: this.state.homeVideo,
                tile:list
          }
          
          this.state.fourTiles.forEach(event => {            
                delete event['_id']
                // delete event['id']
                // delete event['tileUrlError']
                // delete event['tileObj']
        })
          this.apiserve.sendevent("FPGHomePage|updateSettings", data)  ;
          this.state.fourTiles &&  this.state.fourTiles.map(item=>{
            const blocksFromHtml = htmlToDraft(item.tileSubTitle1);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            item.tileSubTitle1 = EditorState.createWithContent(contentState);
        })

        this.state.fourTiles &&  this.state.fourTiles.map(item=>{
            const blocksFromHtml = htmlToDraft(item.tileSubTitle2);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            item.tileSubTitle2 = EditorState.createWithContent(contentState);
        })
        
    }
    }

    // Sections Preview
    home_page_preview = () => {
        swal({
            icon: home_page,
            className: 'screen_preview_wpr'
        });
    }

    errorMsgPopup = () => {
        this.setState({
            errorPopup:false
        })
    }

    validationUrl = (id) => {
        this.setState({});

        if (this.state.fourTiles && this.state.fourTiles.length > 0) {
            
            const re = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
            this.state.fourTiles.forEach(user => {
                
                if(user._id === id){
                    if (  user.tileUrl !== '' || user.tileUrl === '' || !re.test(String(user.tileUrl).toLowerCase())) {
                        
                        if (user.tileUrl !== '' && !re.test(String(user.tileUrl).toLowerCase())) {
                            user.tileUrlError = 'Please enter valid url.'
                            return
                        }
                        else
                        {
                            user.tileUrlError=''
                            return
                        }
                    }
                }
                
            });
        }
    }
    render() {
        const { headerSubTitle } = this.state;
        const Hours = [
            { value: '12', label: '12' },
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' },
            { value: '11', label: '11' },
        ]
        
        const Mins = [
            { value: '00', label: '00' },
            { value: '15', label: '15' },
            { value: '20', label: '20' },
            { value: '25', label: '25' },
            { value: '30', label: '30' },
            { value: '35', label: '35' },
            { value: '40', label: '40' },
            { value: '45', label: '45' },
            { value: '50', label: '50' },
            { value: '55', label: '55' },
        ]
        
        const Stamps = [
            { value: 'AM', label: 'AM' },
            { value: 'PM', label: 'PM' }
        ]
        
        let name = (this.state.updateBy && this.state.updateBy && this.state.updateBy.fname) + ' ' + (this.state.updateBy && this.state.updateBy && this.state.updateBy.lname)

        var updatedAt = new Date(this.state.updatedAt);
        // countDownDateFinal.setHours( this.state.Stamps.value === 'PM' || this.state.Stamps.value === 'pm' ? parseInt(this.state.Hours.value) + 12 : parseInt(this.state.Hours.value), this.state.Mins.value);
        return (
            <React.Fragment>
                {/* <MainLayout history={this.props.history}> */}
                    <div className="right_side_wrapper home_page_cms_section">
                        <div className="dashboard_header">
                            <div className="searchBlock">
                                <span className="uppercase">home Page Content</span>
                            </div>
                            <div className="button_block">
                                <button onClick={() => this.home_page_preview() }>
                                    <img src={QuestionIcon} alt="Question" title="Question"/>
                                </button>
                            </div>
                        </div>
                        {this.state.updatedAt === undefined ? '' :
                        <div className="last_updated_section">
                            <p>Last Update: {moment(updatedAt).format('h:mm A') + ' ' + moment(updatedAt).format('MM/DD/YYYY')} - Last Updated By: {name}</p>
                        </div>
                           }

                        <div className="dashboard_data">
                            <div className="home_page_cms_wpr">
                                <div className="home_page_cms_container">
                                    <form>
                                        <div className="home_page_cms">
                                            <div className="home_page_cms_data">
                                                <div className="home_page_video_block">
                                                    {/* Video */}
                                                    <div className="form_group"> 
                                                        <div className="form_group_inner"> 
                                                            <label>Homepage Video</label>
                                                            <div className="form_group_video loader-main">
                                                                <span className="form_note">Upload mp4 of max size of 200MB</span>
                                                                <input name="homeVideo" 
                                                                    id="myInput"
                                                                    type="file"
                                                                    ref={(ref) => this.videoUp = ref}
                                                                    style={{ display: 'none' }}
                                                                    onChange={this.handleVideo.bind(this)}
                                                                    className="file-upload"
                                                                    accept=".mp4"
                                                                />
                                                                <div className="form_group_video_wpr">
                                                                {this.state.videoPreLoader ?
                                                                <Loader/>
                                                                :   
                                                                <>
                                                                    <Player
                                                                        playsInline
                                                                        autoPlay={false}
                                                                        type="video/mp4"
                                                                        src={this.apiserve.imageUrl +  this.state.homeVideo}
                                                                    >
                                                                        <ControlBar autoHide={false} disableDefaultControls={true}>
                                                                            <PlayToggle />
                                                                        </ControlBar>
                                                                    </Player>
                                                                </>
                                                                }
                                                                </div>
                                                                <span className="add_video">
                                                                    <img src={PlusIcon} className="video_add_icon" onClick={() => { this.videoUp.click() }}/>   
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <span className="error_msg">Please add Homepage video.</span>                                                
                                                    </div>  

                                                    {/* Thumbnail */}
                                                    <div className="form_group"> 
                                                        <div className="form_group_inner"> 
                                                            <label>Homepage Video Thumbnail</label>
                                                            <div className="form_group_video loader-main">
                                                                <span className="form_note">Upload PNG/JPEG of max size of 3MB</span>
                                                                <input name="homeVideo" 
                                                                    type="file"  
                                                                    type="file"
                                                                    ref={(ref) => (this.thumbnail = ref)}
                                                                    onChange={this.handleThumbnail.bind(this)}
                                                                    accept=".png, .jpg, .jpeg"
                                                                />
                                                                <div class="form_group_img_wpr">
                                                                { this.state.thumbnailPreloader ?
                                                                <Loader/>
                                                                :
                                                                <img className="title_content_image" src={
                                                                    this.state.homeVideoThumbnail  ?
                                                                        this.apiserve.imageUrl + this.state.homeVideoThumbnail
                                                                    : '/placeholder.png'
                                                                } />
                                                                }
                                                                </div>
                                                                <span className="add_video">
                                                                    <img src={PlusIcon} className="video_add_icon" onClick={() => { this.thumbnail.click() }}/>   
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <span className="error_msg">Please add Homepage Video Thumbnail.</span>                                                
                                                    </div>  
                                                </div>
                                                <div class="home_page_details_block">
                                                    <div className="form_group form_group_input"> 
                                                        <TextField name="headerTitle" label="Header Title" value={this.state.headerTitle} type="text" onChange={this.handleText}/>
                                                        <span className="error_msg">Please enter header title.</span>                                                
                                                    </div>

                                                    <div className="form_group form_group_textarea"> 
                                                        <div className="form_group_inner"> 
                                                            <label>Header Subtitle</label>
                                                            {/* <textarea name="headerSubTitle" value={this.state.headerSubTitle} rows="6" onChange={this.handleText}></textarea>       */}
                                                            {/* <TextEditor 
                                                                height="200px"
                                                                editorState={headerSubTitle}
                                                                onEditorStateChange={this.onEditorStateChange}
                                                            />   
                                                            */}
                                                            <Editor
                                                            wrapperClassName="sd_text_editor"   
                                                            editorState={this.state.editorState}
                                                            onEditorStateChange={this.onEditorStateChange}      
                                                            toolbar={{
                                                                blockType: {
                                                                    inDropdown: true,
                                                                    options: ['Normal', 'Blockquote'],
                                                                },
                                                                inline: { inDropdown: true },
                                                                list: { inDropdown: true },
                                                                textAlign: { inDropdown: true },
                                                                link: { inDropdown: true },
                                                                history: { inDropdown: true }, 
                                                                options: ['inline', 'blockType', 'list', 'link', 'textAlign'], 
                                                                
                                                            }}
                                                            editorStyle={{ height: '200px' }}
                                                        />
                                                        </div>
                                                        <span className="error_msg">Please enter header subtitle.</span>                                                
                                                    </div>

                                                    <div className="form_group form_group_input"> 
                                                        <div className="form_group_inner"> 
                                                            <label>Countdown Date Time</label> 
                                                            <div className="form_group_countdown">
                                                                <TextField type="text" name="countDownDate"
                                                                    value={moment(this.state.countDownDate).format(
                                                                        "MM/DD/YYYY"
                                                                    )}
                                                                    placeholder="mm / dd / yyyy"
                                                                />              
                                                                                
                                                                <span className="calendar_img">
                                                                    {/* <img src={calendar} alt="calendar icon" title="calendar icon"/>   */}
                                                                    <DatePicker
                                                                           selected={this.state.countDownDate}
                                                                            onChange={this.handleChange}
                                                                            minDate={moment().toDate()}
                                                                            placeholder="mm/dd/yyyy"
                                                                            customInput={
                                                                            <img
                                                                                src={calendar}
                                                                                className="calendar"
                                                                            />
                                                                            }
                                                                    />      
                                                                </span>

                                                                <Select 
                                                                    options={Hours}
                                                                    value={this.state.Hours}
                                                                    name='Hours'
                                                                    placeholder="7"
                                                                    onChange={this.handleTimeHours}/>
                                                                <Select 
                                                                    options={Mins}
                                                                    value={this.state.Mins}
                                                                    name='Mins'
                                                                    placeholder="30"
                                                                    onChange={this.handleTimeMins}
                                                                />
                                                                <Select 
                                                                    options={Stamps}
                                                                    value={this.state.Stamps}
                                                                    name='Stamps'
                                                                    placeholder="AM"
                                                                    onChange={this.handleTimeStamps}
                                                                />   
                                                            </div>   
                                                        </div>   
                                                        <span className="error_msg">Please enter countdown time.</span>                                                
                                                    </div>

                                                    <div className="form_group countDownText"> 
                                                        <div className="form_group_inner"> 
                                                            <label>Countdown text</label> 
                                                            <textarea rows="2"  name="countDownText" value={this.state.countDownText} onChange={this.handleText}></textarea>                                                  
                                                        </div>
                                                        <span className="error_msg">Please enter countdown text.</span>                                                
                                                    </div>
                                                </div>                                                
                                            </div> 
                                            <div className="home_page_cms_tiles">
                                                {this.state.fourTiles && this.state.fourTiles.length && this.state.fourTiles.map(item=>{
                                                     const imagePreloaderState = `imagePreloader_${item._id}`
                                                        return(
                                                        // <HomePageTile 
                                                        //     Tile={item.tileObj} 
                                                        //     imageErr={this.state.imageErr} 
                                                        //     onChange={this.handleChangeTile} 
                                                        //     imageChange={this.handleImage} 
                                                        //     tileTitle={item.tileTitle} 
                                                        //     value={item} data={item}
                                                        //     // urlValidation={this.validator}
                                                        //     ref='HomePageTile'
                                                        // />

                                                        <div className="home_page_title_wpr">
                                                        <div className="title_header">
                                                            <p>{item.tileObj}</p>
                                        
                                                            <div class="tile_dropdown">
                                                                <select 
                                                                    value={item.tileOutbound}
                                                                    id={item.tileOutbound}
                                                                    name='tileOutbound'
                                                                    onChange={(e)=>this.handleChangeBound(e,item)}>  
                                                                    <option value={false} selected={item.tileOutbound ? false : true}>Post</option>
                                                                    <option value={true} selected={item.tileOutbound ? true : false}>Outbound</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="title_content">
                                                            <div className="title_content_img">
                                                                <div className="title_content_img_box loader-main">
                                                                    <input 
                                                                        type="file"  
                                                                        id={item._id}
                                                                        ref={(ref) => (this.uploadImage = ref)}
                                                                        onChange={(e)=>this.handleImageChange(e,item._id)}
                                                                        accept=".png, .jpg, .jpeg"
                                                                    />
                                                                    {
                                                                    this.state[imagePreloaderState]?
                                                                            <Loader/>
                                                                            :
                                                                            <img className="title_content_image" src={
                                                                                item.tileImage  ?
                                                                                    this.apiserve.imageUrl + item.tileImage 
                                                                                : '/placeholder.png'
                                                                            } />
                                                                    }
                                                                    <span className="add_img">
                                                                        <img src={PlusIcon} className="img_add_icon" />
                                                                    </span>
                                                                    <span className="error_msg">{item.imageErr}</span>
                                                                </div>
                                                                <span className="error_note">Max size 3MB</span>
                                                                {item.tileOutbound === false &&
                                                                <div className="form_group form_group_input"> 
                                                                    <TextField  label="Image description" name="tileImageDescription" value={item.tileImageDescription} type="text" onChange={(e)=>this.handleChangeTile(e,item)} />
                                                                    <span className="error_msg">Please enter tile title.</span>                                                
                                                                </div>
                                                                     }
                                                            </div>
                                                            <div className="title_content_form">
                                                                
                                                                <div className="form_group form_group_input"> 
                                                                    <TextField name="tileTitle" name='tileTitle' value={item.tileTitle} label="Tile Title" type="text" onChange={(e)=>this.handleChangeTile(e,item)}/>
                                                                    <span className="error_msg">Please enter tile title.</span>                                                
                                                                </div>
                                        
                                                                {item.tileOutbound === false &&
                                                                <>
                                                                    <div className="form_group form_group_input">
                                                                        <div className="field_row_inner">
                                                                            <label>Tile Subtext 1</label>
                                                                            <div className="field_input relative">
                                                                                <Editor
                                                                                    wrapperClassName="sd_text_editor"   
                                                                                    editorState={item.tileSubTitle1}
                                                                                    onEditorStateChange={(e)=>this.onEditorStateChange(e,item._id, 1)}      
                                                                                    toolbar={{
                                                                                        blockType: {
                                                                                            inDropdown: true,
                                                                                            options: ['Normal', 'Blockquote'],
                                                                                        },
                                                                                        inline: { inDropdown: true },
                                                                                        list: { inDropdown: true },
                                                                                        textAlign: { inDropdown: true },
                                                                                        link: { inDropdown: true },
                                                                                        history: { inDropdown: true }, 
                                                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign'], 
                                                                                        
                                                                                    }}
                                                                                    editorStyle={{ height: '200px' }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    
                                                                    </div> 
                                                                    {/* <div className="form_group form_group_textarea"> 
                                                                        <div className="form_group_inner"> 
                                                                            <label>Tile Subtext 1</label> 
                                                                            <textarea rows="11" name="tileSubTitle1" value={item.tileSubTitle1} onChange={(e)=>this.handleChangeTile(e,item)}></textarea>                                                  
                                                                        </div>
                                                                        <span className="error_msg">Please enter tile subtitle.</span>                                                
                                                                    </div> */}

                                                                    <div className="form_group form_group_input">
                                                                        <div className="field_row_inner">
                                                                            <label>Tile Subtext 2</label>
                                                                            <div className="field_input relative">
                                                                                <Editor
                                                                                    wrapperClassName="sd_text_editor"   
                                                                                    editorState={item.tileSubTitle2}
                                                                                    onEditorStateChange={(e)=>this.onEditorStateChange(e,item._id,2)}
                                                                                    toolbar={{
                                                                                        blockType: {
                                                                                            inDropdown: true,
                                                                                            options: ['Normal', 'Blockquote'],
                                                                                        },
                                                                                        inline: { inDropdown: true },
                                                                                        list: { inDropdown: true },
                                                                                        textAlign: { inDropdown: true },
                                                                                        link: { inDropdown: true },
                                                                                        history: { inDropdown: true }, 
                                                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign'], 
                                                                                        
                                                                                    }}
                                                                                    editorStyle={{ height: '200px' }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    
                                                                    </div> 
                                        
                                                                    {/* <div className="form_group form_group_textarea"> 
                                                                        <div className="form_group_inner"> 
                                                                            <label>Tile Subtext 2</label> 
                                                                            <textarea rows="19" name="tileSubTitle2" value={item.tileSubTitle2} onChange={(e)=>this.handleChangeTile(e,item)}></textarea>                                                  
                                                                        </div>
                                                                        <span className="error_msg">Please enter tile subtitle.</span>                                                
                                                                    </div> */}
                                                                </>
                                                                }
                                                                {/* <div className="form_group form_group_input">
                                                                    <div className="field_row_inner">
                                                                        <label>Tile Subtext 1</label>
                                                                        <div className="field_input relative">
                                                                            <Editor
                                                                                wrapperClassName="sd_text_editor"   
                                                                                editorState={this.state.editorState}
                                                                                onEditorStateChange={this.onEditorStateChange}      
                                                                                toolbar={{
                                                                                    blockType: {
                                                                                        inDropdown: true,
                                                                                        options: ['Normal', 'Blockquote'],
                                                                                    },
                                                                                    inline: { inDropdown: true },
                                                                                    list: { inDropdown: true },
                                                                                    textAlign: { inDropdown: true },
                                                                                    link: { inDropdown: true },
                                                                                    history: { inDropdown: true }, 
                                                                                    options: ['inline', 'blockType', 'list', 'link', 'textAlign'], 
                                                                                    
                                                                                }}
                                                                                editorStyle={{ height: '200px' }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                
                                                                </div> */}
                                                                <div className="form_group form_group_input form_group_input_cta"> 
                                                                    <TextField name="tileCTA" label="Tile CTA" value={item.tileCTA} type="text" onChange={(e)=>this.handleChangeTile(e,item)}/>
                                                                    <span className="error_msg">Please enter tile cta.</span>                                                
                                                                </div>


                                                                {item.tileOutbound === true &&
                                                                <>
                                                                <div className="form_group form_group_input"> 
                                                                    <TextField name="tileUrl" value={item.tileUrl} label="Tile URL" type="text" onChange={(e)=>this.handleChangeTile(e,item)} onBlur={()=>this.validationUrl(item._id)} placeholder="https://gotourl.com" />
                                                                    <span style={{ color: 'red' }}>{item.tileUrlError}</span>
                                                                </div>
                                                                </>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                        )
                                                    })
                                                }
                                            </div> 
                                        </div> 

                                        <div className="form_submit_buttons">
                                            <button className="form_btns form_cancel_btn grey_btn">Cancel</button>
                                            <button
                                                className="form_btns form_submit_btn yellow_btn"
                                                type='button' 
                                                disabled={this.state.videoPreLoader ? true : false}
                                                onClick={()=>this.submit()}>Save</button>
                                        </div>
                                    </form>
                                </div> 
                            </div> 
                        </div>
                    </div>
                    {this.state.errorPopup ? 
                            <ErrorPopUp
                            errorMsg={this.state.errorMsg}
                            errorMsgPopup={this.errorMsgPopup}
                            />    
                        : ''
                    }
                {/* </MainLayout> */}
            </React.Fragment>
        )
    }
}
export default HomePageCms;